import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesignerDispatcher from "./hooks/useDesignerDispatcher";
import useDesignerMessage from "./hooks/useDesignerMessage";

export default function SiderToolbarController(props) {

    const [selectedSider, setSelectedSider] = useState();

    const dispatcher = useDesignerDispatcher();

    useEffect(() => {
        dispatcher("selectedSiderChanged", { location: props.location, name: selectedSider });
    }, [selectedSider, dispatcher]);

    useDesignerMessage(e => {
        if (e.location === props.location)
            setSelectedSider(e.name);
    }, "selectSider");

    return (props.addons || []).filter(c => c.location === props.location)?.length && <>
        <div className='toolgroup'>
            {
                (props.addons || []).filter(c => c.location === props.location).map((c, i) => {
                    return (
                        <Tooltip title={c.alias || c.name} placement="bottom">
                            <Button
                                className='btn-switch'
                                type={selectedSider === c.name ? "primary" : "default"}
                                onClick={e => setSelectedSider(selectedSider === c.name ? null : c.name)}
                            >
                                <Application.SystemSvgIcon type={c.svgIcon} />
                            </Button>
                        </Tooltip>
                    );
                })
            }
        </div>
    </> || null
}